var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlendingMode = function SvgBlendingMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "currentColor",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.2 9.6c0-2.667 1.6-5.067 4.8-8 3.2 2.933 4.8 5.333 4.8 8a4.8 4.8 0 0 1-9.6 0m8.483-.743c-1.365-.514-2.843.17-4.228.81-1.127.521-2.192 1.014-3.085.81a3.7 3.7 0 0 1-.103-.877c0-2.014 1.095-3.977 3.733-6.535 2.313 2.243 3.44 4.028 3.682 5.792",
    clipRule: "evenodd"
  })));
};
export default SvgBlendingMode;